import React from 'react';

import { Actions, Action, FileCopyIcon, EditIcon } from '@gogame/components';

import { ACTION_EDIT, ACTION_DUPLICATE } from 'scenes/Campaigns/constants';

export const ParentCampaignActions = ({ limit = 0, onEdit, onDuplicate }) => {
  return (
    <Actions limit={limit}>
      <Action
        id={ACTION_EDIT}
        icon={<EditIcon />}
        label={'Edit'}
        onClick={onEdit}
      />
      <Action
        id={ACTION_DUPLICATE}
        icon={<FileCopyIcon />}
        label={'Duplicate'}
        onClick={onDuplicate}
      />
    </Actions>
  );
};
